export function requestPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_REQUEST',
        vin,
        assignmentInstanceId
    }
}

export function retryPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_RETRY',
        vin,
        assignmentInstanceId
    }
}

export function receivePatEligibilitySuccess(vin, assignmentInstanceId, result) {
    return {
        type: 'PAT_ELIGIBILITY_SUCCESS',
        vin,
        assignmentInstanceId,
        result
    }
}

export function receivePatEligibilityError(vin, assignmentInstanceId, errorMessage) {
    return {
        type: 'PAT_ELIGIBILITY_ERROR',
        vin,
        assignmentInstanceId,
        errorMessage
    }
}

export function discardPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_DISCARD',
        vin,
        assignmentInstanceId
    }
}

export function selectPatSaleType(vin, assignmentInstanceId, saleType) {
    return {
        type: 'PAT_ELIGIBILITY_SELECT_SALE_TYPE',
        vin,
        assignmentInstanceId,
        saleType
    }
}

export function revertPatSaleType(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_REVERT',
        vin,
        assignmentInstanceId
    }
}

export function undoPatSaleType(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_UNDO',
        vin,
        assignmentInstanceId
    }
}
